import Cookies from './cookies'
import Menu from './menu'
import Submenu from './submenu'
import MenuManager from './open-menu'
import FiltersManager from './filters-manager'
import DetailsManager from './details-manager'
import MySwiper from './my-swiper'
import Checkout from './checkout'
import SelectFillManager from './select-fill'
import ShipFill from './shipping-method-fill'
import ValueDisplay from './value-display'
import Sum from './sum'
import Search from './search'
import DetailsInactiveOnDesktopManager from './details-inactive-desktop'
import FormManager from './form-manager'
import InputActionButtons from './input-action-buttons'
import HeaderShadow from './header-shadow'
import OnLoad from './on-load'
import AuthCheckout from './auth-checkout-fill'
import FindOptionManager from './find-option'
import SearchFocus from './search-focus'
import PopupMessage from './popup-message'
import PopupMessageBase from './popup-message-base'
import PopupClear from './popup-clear'
import StripeDisplay from './stripe'
import BrowserCheck from './browser-check'
import LastInputTabManager from './last-input-tab'
import ActiveAction from './active-action'
import VariantUpdate from './variant-update'
import PageLoadAnimation from './page-load-animation'
// import DetailsBlur from './details-blur'
import PopupOnhash from './popup-onhash'
import ClickAvoidPropagation from './click-avoid-propagation'
import MBWait from './mbwait'
import AsyncPaymentChecks from './async-payment-checks'
import VhRecalculate from './vh-recalculate'
import CountryPick from './country-pick'
import 'details-element-polyfill'
import SKSwiper from './sk-swiper'
import QuantitySelector from './quantity-selector'
import HiddenCheckboxManager from './hidden-checkbox'
import SubmitCP from './submit-cp'
import TelPrefix from './tel-prefix'
import TableAddRowManager from './table-add-row-manager'
import MySwiper2 from './my-swiper-2'
import ResumeCartProduct from './resume-cart-product'
import HideLink from './hide-link'
import AsyncForm from './async-form'
import BackNav from './back-nav'
import SKToggle from './sk-toggle'
import AutoFoldSKPanel from './auto-fold-sk-panel'
import AsyncNextStep from './async-next-step'
import FormAnimatedGroup from './form-animated-group'
import LinkLoading from './link-loading'

class App {
    constructor() {
        this.browserCheck = new BrowserCheck()
        if (this.browserCheck.isIE) {
            return;
        }
        this.cookies = new Cookies()
        this.vhRecalculate = new VhRecalculate()
        this.menu = new Menu()
        this.submenu = new Submenu()
        this.menuManager = new MenuManager()
        this.filtersManager = new FiltersManager()
        this.DetailsManager = new DetailsManager()
        this.mySwiper = new MySwiper()
        this.stripe = new StripeDisplay()
        this.checkout = new Checkout()
        this.selectFillManager = new SelectFillManager()
        this.shipFill = new ShipFill()
        this.sum = new Sum()
        this.valueDisplay = new ValueDisplay()
        this.search = new Search()
        this.detailsInactiveOnDesktopManager = new DetailsInactiveOnDesktopManager()
        this.pageLoadAnimation = new PageLoadAnimation()
        this.formManager = new FormManager(this)
        this.inputActionButtons = new InputActionButtons()
        this.headerShadow = new HeaderShadow()
        this.onLoad = new OnLoad()
        this.findOptionManager = new FindOptionManager()
        this.authCheckout = new AuthCheckout()
        this.searchFocus = new SearchFocus()
        this.popupMessage = new PopupMessage()
        this.popupMessageBase = new PopupMessageBase()
        this.clickAvoidPropagation = new ClickAvoidPropagation()
        this.popupClear = new PopupClear()
        this.lastInputTabManager = new LastInputTabManager()
        this.activeAction = new ActiveAction()
        this.variantUpdate = new VariantUpdate()
        // this.detailsBlur = new DetailsBlur()
        this.popupOnhash = new PopupOnhash()
        this.mbWait = new MBWait()
        this.asyncPaymentChecks = new AsyncPaymentChecks()
        this.countryPick = new CountryPick()
        this.skSwiper = new SKSwiper()
        this.quantitySelector = new QuantitySelector()
        this.hiddenCheckboxManager = new HiddenCheckboxManager();
        this.submitCP = new SubmitCP();
        this.telPrefix = new TelPrefix();
        this.tableAddRowManager = new TableAddRowManager();
        this.mySwiper2 = new MySwiper2();
        this.resumeCartProduct = new ResumeCartProduct();
        this.hideLink = new HideLink();
        this.asyncForm = new AsyncForm();
        new BackNav();
        new SKToggle();
        new AutoFoldSKPanel();
        new AsyncNextStep();
        new FormAnimatedGroup();
        new LinkLoading();
    }
}

export default App